// Components
import {
    isValidUrl,
    filter,
    fitIn,
    size,
    isAllowedImage,
} from "./src/utils/imageHandlerUtils";
import {
    forAspectRatio,
    getImageRef,
    forFixedHeight,
    getResolutions,
} from "./src/utils/imageUtils";

export {MemberAvatar} from "./src/feature/components/MemberAvatar/MemberAvatar";
export {ResponsiveImage} from "./src/feature/components/ResponsiveImage/ResponsiveImage";
export {Image} from "./src/feature/components/Image/Image";
export {ImageUploadModal} from "./src/feature/components/ImageUploadModal/ImageUploadModal";
export {initImagesConfig} from "./src/feature/storybook/storyImages";
export {imageRadius} from "./src/feature/components/Image/Image.styles";
export {mapUrl} from "./src/feature/components/MemberAvatar/MemberAvatar";
export {imageBorder as imageBorderStyle} from "./src/feature/components/Image/Image.styles";
export {ImageDropzone} from "./src/feature/components/ImageDropzone/ImageDropzone";

export {CloudfrontHelper} from "./src/utils/cloudfront.helper";

export {ImageSrc} from "./src/utils/imageSrc.builder";
export const ImageUtils = {
    isValidUrl,
    filter,
    fitIn,
    size,
    isAllowedImage,
    forAspectRatio,
    getImageRef,
    forFixedHeight,
    getResolutions,
};

// Types
export {
    type ImageAspectRatio,
    ASPECT_RATIO_1_1,
    ASPECT_RATIO_4_3,
    ASPECT_RATIO_191_1,
    ASPECT_RATIO_21_1,
    ASPECT_RATIO_3_2,
    ASPECT_RATIO_16_9,
    aspectRatio,
} from "./src/types/aspectRatio";
export {
    MEMBER_IMAGE_OPTIONS,
    TEAM_IMAGE_OPTIONS,
    BATCH_BET_IMAGE_OPTIONS,
    SHOP_IMAGE_OPTIONS,
    ImageLabelType,
} from "./src/types/image";
export type {
    ImageRef,
    ImageUrl,
    ResponsiveImageProps,
    BorderProps,
    ImageFileOptions,
    UploadableFile,
    ImageFilePayload,
    ImagesConfig,
} from "./src/types/image";
